'use strict'

/* global Hammer */

import 'hammerjs'

import { initVideo, closeVideo } from './utils'
import { getSrc } from './responsiveImage'

/** @module slider/sliderHandler
 * */

/** @const {string} */
const TIMER = 1000
/** @const {string} */
const AUTOPLAY_TIMER = 6000
/** @const {string} */
const REFRESH_STEP = 1
/** @const {string} */
const CLASS_ACTIV = 'activ'
/** @const {string} */
const CLASS_CURRENT = 'current'
/** @let {string} */
let CLASS_MOVE_LIST_LEFT = 'move-list-left'
/** @let {string} */
let CLASS_MOVE_LIST_RIGHT = 'move-list-right'
/** @const {string} */
const CLASS_MOVE_LIST_LEFT_33 = 'move-list-left-33'
/** @const {string} */
const CLASS_MOVE_LIST_RIGHT_33 = 'move-list-right-33'
/** @const {string} */
const CLASS_MOVE_LIST_LEFT_25 = 'move-list-left-25'
/** @const {string} */
const CLASS_MOVE_LIST_RIGHT_25 = 'move-list-right-25'
/** @const {string} */
const CLASS_MOVE_THUMBS_LEFT = 'move-thumbs-left'
/** @const {string} */
const CLASS_MOVE_THUMBS_RIGHT = 'move-thumbs-right'
/** @const {string} */
const CLASS_SHOW_THUMBS_LEFT = 'show-thumbs-left'
/** @const {string} */
const CLASS_SHOW_THUMBS_RIGHT = 'show-thumbs-right'
/** @const {string} */
const CLASS_EMBED_VIDEO = 'js-embed-video'
/** @const {string} */
const SELECTOR_ZOOM_GAL = '.galerie-photos-zoom'
/** @const {string} */
const CLASS_SMALL_MOSAIC = 'small-mosaic'
/** @const {string} */
const CLASS_BIG_MOSAIC = 'big-mosaic'
/** @const {string} */
const CLASS_LAZYLOAD = 'js-lazyload'
/** @const {string} */
const SELECTOR_CLASS_ACTIV = `.${CLASS_ACTIV}`
/** @const {string} */
const SELECTOR_CLASS_CURRENT = `.${CLASS_CURRENT}`
/** @const {string} */
const ATTRIBUTE_ORIGINAL = 'data-original'
/** @const {string} */
const $body = document.body

/**
 * Slider handler
 *
 * @method default
 * @param {object} options {
mainGallery,
mainPrevArrow,
mainNextArrow,
secondaryGallery,
secondaryPrevArrow,
secondaryNextArrow,
paginationSelector,
paginationFormat,
zoomGal,
zoomGalTop,
sliderThumb,
sliderThumbPrevArrow,
sliderThumbNextArrow,
synchronizeGal
}
 */
export default function (options = {}) {
  const sliderSelector = options.mainGallery
  const previousSelector = options.mainPrevArrow
  const nextSelector = options.mainNextArrow
  const thumbSelector = options.secondaryGallery
  const thumbPreviousSelector = options.secondaryPrevArrow
  const thumbNextSelector = options.secondaryNextArrow
  const paginationSelector = options.paginationSelector
  const paginationFormat = options.paginationFormat
  const zoomGal = options.zoomGal
  const zoomGalTop = options.zoomGalTop
  const sliderThumb = options.sliderThumb
  const sliderThumbEltClickable = options.sliderThumbEltClickable || 'span, li'
  const sliderThumbPrev = options.sliderThumbPrevArrow
  const sliderThumbNext = options.sliderThumbNextArrow
  const synchronize = options.synchronizeGal === void 0 ? true : options.synchronizeGal
  const swipeContainer = options.swipeContainer
  const autoplay = options.autoplay || false
  let leftClass = CLASS_MOVE_LIST_LEFT
  let rightClass = CLASS_MOVE_LIST_RIGHT

  // Status of slider animation (bool)
  let animate = false
  // Width of thumbnails item (int)
  let thumbItemWidth = 0
  // Number of thumbnails item (int)
  let thumbNbItems = 0
  // Position max of active element (int)
  let limit = 0
  // Timer value (int)
  let t = 0
  // Slider selector
  let $sliderSelector = sliderSelector
  let isMiniSlide = $sliderSelector.classList.contains('mini-slide') && window.innerWidth > 1023
  const isMiniSlideVideo = isMiniSlide && $sliderSelector.classList.contains('like-video')
  const isGaleriePhotos = $sliderSelector.classList.contains('galerie-photos')

  if ($sliderSelector.classList.contains('mini-slide')) {
    window.addEventListener('resize', () => {
      if (isMiniSlide && window.innerWidth < 1024) {
        isMiniSlide = false
        leftClass = CLASS_MOVE_LIST_LEFT
        rightClass = CLASS_MOVE_LIST_RIGHT
      } else if (!isMiniSlide && window.innerWidth > 1023) {
        isMiniSlide = true
        leftClass = CLASS_MOVE_LIST_LEFT_33
        rightClass = CLASS_MOVE_LIST_RIGHT_33
      }
    })
  }

  if (isGaleriePhotos || isMiniSlide) {
    leftClass = CLASS_MOVE_LIST_LEFT_33
    rightClass = CLASS_MOVE_LIST_RIGHT_33
  }
  if (isMiniSlideVideo) {
    leftClass = CLASS_MOVE_LIST_LEFT_25
    rightClass = CLASS_MOVE_LIST_RIGHT_25
  }
  // Thumb selector
  let $thumbSelector = $sliderSelector.querySelector(thumbSelector)
  // Zoom Thumb selector
  let $sliderThumb = null
  // Swipe container
  let $swipeContainer = null
  // Zoom Gallery selector
  let $zoomGal = typeof zoomGal === 'string' ? $sliderSelector.querySelector(zoomGal) : zoomGal
  // Index of active element (int)
  let count = 0
  // let add_ids = []

  const $sliderList = $sliderSelector.getElementsByTagName('ul').item(0)

  const $sliderLi = $sliderList.getElementsByTagName('li').item(0)

  // If sliderList && sliderLi exist
  if ($sliderSelector && $sliderLi) {
      $sliderList.firstElementChild.classList.add(CLASS_ACTIV, CLASS_CURRENT)
      $swipeContainer = swipeContainer ? $sliderSelector.querySelector(swipeContainer) : $sliderList
  }

  // If has zoom thumbnails
  if (zoomGalTop !== void 0 && sliderThumb !== void 0) {
    $sliderThumb = $sliderSelector.querySelector(sliderThumb)
  }

  let autoInterval = null

  function handleInitVideo(target) {
    switch (true) {
      case isGaleriePhotos:
        if (target.classList.contains(CLASS_EMBED_VIDEO)) {
          initVideo(target)
        }
        break
      default:
    }
  }

  function handleCloseVideo(target) {
    switch (true) {
      case isGaleriePhotos:
        if (target.classList.contains(CLASS_EMBED_VIDEO)) {
          closeVideo(target)
        }
        break
      case isMiniSlideVideo:
        if (target && target.firstElementChild.classList.contains(CLASS_EMBED_VIDEO)) {
          closeVideo(target.firstElementChild)
        }
        break
      default:
    }
  }

  /**
   * Slide right
   *
   * @function moveRight
   * @param {...*} params [e,time]
   */
  function moveRight(...params) {
    if (autoplay) {
      clearInterval(autoInterval)
      autoInterval = setInterval(autoPlay, AUTOPLAY_TIMER)
    }
    const e = params[0]
    let time = params[1]
    t = 0
    animate = true
    const $target = $sliderSelector
    const $list = $target.getElementsByTagName('ul').item(0)
    let $current = $list.getElementsByClassName(CLASS_CURRENT).item(0)
    const $next = $current.nextElementSibling
    const $nextLazyloadPictures = $list.querySelectorAll('picture')
    const $nextLazyloadImgs = $list.querySelectorAll('img')
    const $nextLazyloadThumbPictures = $thumbSelector && $thumbSelector.querySelectorAll('picture')
    const $nextLazyloadThumbImgs = $thumbSelector && $thumbSelector.querySelectorAll('img')
    const $nextImg = $next.getElementsByTagName('img').item(0)

    if (time === void 0) {
      time = TIMER
    }

    if ($nextImg) {
      $nextImg.removeAttribute('style')
    }

    for (let i = 0; i < 7; i++) {
      if ($nextLazyloadImgs[i] && $nextLazyloadPictures[i].classList.contains(CLASS_LAZYLOAD)) {
        let src = getSrc($nextLazyloadPictures[i])
        if (src || $nextLazyloadImgs[i].getAttribute(ATTRIBUTE_ORIGINAL)) {
          if ($nextLazyloadThumbPictures
              && $nextLazyloadThumbPictures[i]
              && $nextLazyloadThumbPictures[i].classList.contains(CLASS_LAZYLOAD)) {
            $nextLazyloadThumbPictures[i].classList.remove(CLASS_LAZYLOAD)
            if ($nextLazyloadThumbImgs
                && $nextLazyloadThumbImgs[i]
                && $nextLazyloadThumbImgs[i].getAttribute(ATTRIBUTE_ORIGINAL)) {
              $nextLazyloadThumbImgs[i].setAttribute(
                'src',
                $nextLazyloadThumbImgs[i].getAttribute(ATTRIBUTE_ORIGINAL)
              )
            }
          }
          $nextLazyloadPictures[i].classList.remove(CLASS_LAZYLOAD)
          $nextLazyloadImgs[i]
            .setAttribute('src', src || $nextLazyloadImgs[i].getAttribute(ATTRIBUTE_ORIGINAL))
        }
      }
    }

    $next.classList.add(CLASS_ACTIV)

    // If has thumbnail
    if ($thumbSelector) {
      const activ = $thumbSelector.getElementsByClassName(CLASS_ACTIV).item(0)
      const activIndex = activ.index()
      if (activIndex > limit + 1) {
        [...$thumbSelector.children].slice(0, activIndex).forEach(item => {
          $thumbSelector.appendChild(item)
        })
        activ.classList.remove(CLASS_ACTIV)
        const next = activ.nextElementSibling
        next.classList.add(CLASS_ACTIV)
      } else if ($thumbSelector.childElementCount > thumbNbItems && activIndex + 1 >= limit) {
        $thumbSelector.classList.add(CLASS_MOVE_THUMBS_RIGHT)
        setTimeout(() => {
          $thumbSelector.classList.remove(CLASS_MOVE_THUMBS_RIGHT)
          activ.classList.remove(CLASS_ACTIV)
          const next = activ.nextElementSibling
          next.classList.add(CLASS_ACTIV)
          $thumbSelector.appendChild($thumbSelector.firstElementChild)
          animate = false
        }, time)
      } else {
        activ.classList.remove(CLASS_ACTIV)
        const next = activ.nextElementSibling
        if (next) {
          next.classList.add(CLASS_ACTIV)
        } else {
          $thumbSelector.firstElementChild.classList.add(CLASS_ACTIV)
        }
      }
    }

    function animationEnd() {
      $list.className = ''
      $list.removeEventListener('animationend', animationEnd)
      $current.classList.remove(CLASS_CURRENT, CLASS_ACTIV)
      $list.appendChild($current)
      $next.classList.add(CLASS_CURRENT)
      handleCloseVideo($current.firstElementChild)
      handleInitVideo($next.firstElementChild)
      animate = false
      count--
      if (count > 0) {
        t = setTimeout(moveRight(e, time), time)
      }
      let activ = null
      let $thumbs = []
      if ($sliderThumb) {
        activ = $sliderThumb.getElementsByClassName(CLASS_ACTIV).item(0)
        $thumbs = $sliderThumb.getElementsByTagName(activ.tagName)
      }
      let activIndex = -1
      if (activ) {
        activIndex = activ.index()
      }
      activIndex = activIndex === $thumbs.length - 1 ? 0 : activIndex + 1
      if (paginationSelector && $thumbSelector) {
        const paginationText = paginationFormat
          ? paginationFormat.replace('$1', activIndex)
                            .replace('$2', $thumbSelector.childElementCount)
          : 'Photo ' + activIndex + '/' + $thumbSelector.length
        if (document.querySelector(paginationSelector)) {
          document.querySelector(paginationSelector).textContent = paginationText
        }
      }
      if ($zoomGal
          && $zoomGal.classList.contains('gallery')
          && synchronize
          && $zoomGal.classList.contains(CLASS_ACTIV)) {
        let gal = $thumbSelector.getElementsByClassName(CLASS_ACTIV).item(0)
        let galIndex = -1
        if (gal) {
          galIndex = gal.index()
        }
        // add_ids = [45733]

        galIndex = galIndex === $thumbs.length - 1 ? 0 : galIndex + 1
        $thumbSelector.querySelectorAll('> span')[galIndex].click()
      } else {
        // add_ids = [25994]
      }

      /* if (window.sas && REFRESH_STEP) {
       add_ids.forEach(function(id) {
       sas.refresh(id, { forceMasterFlag: true })
       })
       }
       ga('send', 'pageview') */

      if ($sliderThumb) {
        activ.classList.remove(CLASS_ACTIV)
        $thumbs[activIndex].classList.add(CLASS_ACTIV)
      }
    }

    // Play animate
    if ($list.querySelectorAll('li').length) {
      $list.classList.add(rightClass)
      $list.addEventListener('animationend', animationEnd)
    }
  }

  /**
   * Slide left
   *
   * @function moveLeft
   * @param {...*} params [e,time]
   */
  function moveLeft(...params) {
    const e = params[0]
    let time = params[1]
    t = 0
    animate = true
    if (time === void 0) {
      time = TIMER
    }
    const $target = $sliderSelector
    const $list = $target.getElementsByTagName('ul').item(0)
    const $current = $list.getElementsByClassName(CLASS_CURRENT).item(0)
    const $prev = $list.lastElementChild
    const $prevImg = $prev.getElementsByTagName('img').item(0)
    const $prevLazyloadPictures = $list.querySelectorAll('picture')
    const $prevLazyloadImgs = $list.querySelectorAll('img')
    const $prevLazyloadThumbPictures = $thumbSelector && $thumbSelector.querySelectorAll('picture')
    const $prevLazyloadThumbImgs = $thumbSelector && $thumbSelector.querySelectorAll('img')

    if ($prevImg) {
      $prevImg.removeAttribute('style')
    }

    for (let i = 0; i < 5; i++) {
      const j = $prevLazyloadPictures.length - i + 1
      if ($prevLazyloadImgs[j] && $prevLazyloadPictures[j].classList.contains(CLASS_LAZYLOAD)) {
        let src = getSrc($prevLazyloadPictures[j])
        if (src || $prevLazyloadImgs[j].getAttribute(ATTRIBUTE_ORIGINAL)) {
          if ($prevLazyloadThumbPictures
              && $prevLazyloadThumbPictures[j]
              && $prevLazyloadThumbPictures[j].classList.contains(CLASS_LAZYLOAD)) {
            $prevLazyloadThumbPictures[j].classList.remove(CLASS_LAZYLOAD)
            if ($prevLazyloadThumbImgs
                && $prevLazyloadThumbImgs[j]
                && $prevLazyloadThumbImgs[j].getAttribute(ATTRIBUTE_ORIGINAL)) {
              $prevLazyloadThumbImgs[j].setAttribute(
                'src',
                $prevLazyloadThumbImgs[j].getAttribute(ATTRIBUTE_ORIGINAL)
              )
            }
          }
          $prevLazyloadPictures[j].classList.remove(CLASS_LAZYLOAD)
          $prevLazyloadImgs[j].setAttribute('src', src || $prevLazyloadImgs[j].getAttribute(ATTRIBUTE_ORIGINAL))
        }
      }
    }
    $prev.classList.add(CLASS_ACTIV)
    $list.insertBefore($prev, $list.firstChild)

    // If has thumbnail
    if ($thumbSelector
        && (!SELECTOR_ZOOM_GAL || !e.currentTarget.closest(SELECTOR_ZOOM_GAL))) {
      const activ = $thumbSelector.getElementsByClassName(CLASS_ACTIV).item(0)
      const activIndex = activ.index()
      if (activIndex > limit + 1) {
        [...$thumbSelector.children].slice(0, activIndex - 2).forEach(item => {
          $thumbSelector.appendChild(item)
        })
        const prev = activ.previousElementSibling
        activ.classList.remove(CLASS_ACTIV)
        if (prev) {
          prev.classList.add(CLASS_ACTIV)
        } else {
          $thumbSelector.lastElementChild.classList.add(CLASS_ACTIV)
        }
      } else if ($thumbSelector.childElementCount > thumbNbItems && activIndex + 1 >= limit) {
        $thumbSelector.insertBefore($thumbSelector.lastElementChild, $thumbSelector.firstChild)
        $thumbSelector.classList.add(CLASS_MOVE_THUMBS_LEFT)
        setTimeout(() => {
          $thumbSelector.classList.remove(CLASS_MOVE_THUMBS_LEFT)
          const prev = activ.previousElementSibling
          activ.classList.remove(CLASS_ACTIV)
          if (prev) {
            prev.classList.add(CLASS_ACTIV)
          } else {
            $thumbSelector.lastElementChild.classList.add(CLASS_ACTIV)
          }
          animate = false
        }, time)
      } else {
        if ($thumbSelector.childElementCount > thumbNbItems) {
          $thumbSelector.insertBefore($thumbSelector.lastElementChild, $thumbSelector.firstChild)
          $thumbSelector.classList.add(CLASS_MOVE_THUMBS_LEFT)
          setTimeout(() => {
            $thumbSelector.classList.remove(CLASS_MOVE_THUMBS_LEFT)
          }, time)
        }
        const prev = activ.previousElementSibling
        activ.classList.remove(CLASS_ACTIV)
        if (prev) {
          prev.classList.add(CLASS_ACTIV)
        } else {
          $thumbSelector.lastElementChild.classList.add(CLASS_ACTIV)
        }
      }
    }

    function animationEnd() {
      $list.className = ''
      $list.removeEventListener('animationend', animationEnd)
      $current.classList.remove(CLASS_CURRENT, CLASS_ACTIV)
      $prev.classList.add(CLASS_CURRENT)
      handleCloseVideo(isMiniSlideVideo
        ? $list.children.item(4).firstElementChild
        : $current.firstElementChild)
      handleInitVideo($prev.firstElementChild)
      animate = false
      count--
      if (count > 0) {
        t = setTimeout(moveLeft(e, time), time)
      }
    }

    // Play animate
    if ($list.querySelectorAll('li').length) {
      $list.classList.add(leftClass)
      $list.addEventListener('animationend', animationEnd)
    }

    let activIndex = -1
    let $thumbs = null
    let activ = null
    if ($sliderThumb) {
      activ = $sliderThumb.getElementsByClassName(CLASS_ACTIV).item(0)
      if (activ) {
        activIndex = activ.index()
      }
      $thumbs = $sliderThumb.getElementsByTagName(activ.tagName)
      activIndex = activIndex === 0 ? $thumbs.length - 1 : activIndex - 1
      if (paginationSelector && $thumbSelector) {
        const paginationText = paginationFormat
          ? paginationFormat.replace('$1', activIndex).replace('$2', $thumbSelector.childElementCount)
          : 'Photo ' + activIndex + '/' + $thumbSelector.length
        if (document.querySelector(paginationSelector)) {
          document.querySelector(paginationSelector).textContent = paginationText
        }
      }
    }
    if ($zoomGal
        && $zoomGal.classList.contains('gallery')
        && synchronize
        && $zoomGal.classList.contains(CLASS_ACTIV)) {
      let gal = $sliderSelector.querySelector(`${thumbSelector} ${SELECTOR_CLASS_ACTIV}`)
      let galIndex = -1
      if (gal) {
        galIndex = gal.index()
      }
      // add_ids = [45733]

      galIndex = galIndex === 0 ? $thumbs.length - 1 : galIndex - 1
      $sliderSelector.querySelectorAll(`${thumbSelector} > span`)[galIndex].click()
    } else {
      // add_ids = [25994]
    }

    /* if (window.sas && REFRESH_STEP) {
      add_ids.forEach(function(id) {
        sas.refresh(id, { forceMasterFlag: true })
      })
    }
    ga('send', 'pageview') */

    if ($sliderThumb) {
      activ.classList.remove(CLASS_ACTIV)
      $thumbs[activIndex].classList.add(CLASS_ACTIV)
    }
  }

  /**
   * Show left thumbnails
   *
   * @function showLeft
   * @param {...*} params [e,time]
   */
  function showLeft(...params) {
    const $span = [...$thumbSelector.children]
    let time = params[1]
    animate = true

    if (time === void 0) {
      time = TIMER
    }

    for (let i = 0; i < $span.length; i++) {
      let picture = $span[i].querySelector('picture')
      let img = $span[i].querySelector('img')
      if (picture && picture.classList.contains(CLASS_LAZYLOAD)) {
        let src = getSrc(picture)
        if (src || img.getAttribute(ATTRIBUTE_ORIGINAL)) {
          picture.classList.remove(CLASS_LAZYLOAD)
          img.setAttribute('src', src || img.getAttribute(ATTRIBUTE_ORIGINAL))
        }
      }
    }

    $span.slice($span.length - 3).reverse().forEach(span => {
      $thumbSelector.insertBefore(span.cloneNode(true), $thumbSelector.firstChild)
    })
    $thumbSelector.classList.add(CLASS_SHOW_THUMBS_LEFT)
    setTimeout(() => {
      $thumbSelector.classList.remove(CLASS_SHOW_THUMBS_LEFT)
      $span.slice($span.length - 3).forEach(span => {
        span.parentNode.removeChild(span)
      })
      animate = false
    }, time)
  }

  /**
   * Show right thumbnails
   *
   * @function showRight
   * @param {int} param Duration delay
   */
  function showRight(param) {
    const $span = [...$thumbSelector.children]
    let time = param
    animate = true

    if (time === void 0) {
      time = TIMER
    }

    for (let i = 0; i < $span.length; i++) {
      let picture = $span[i].querySelector('picture')
      let img = $span[i].querySelector('img')
      if (picture && picture.classList.contains(CLASS_LAZYLOAD)) {
        let src = getSrc(picture)
        if (src || img.getAttribute(ATTRIBUTE_ORIGINAL)) {
          picture.classList.remove(CLASS_LAZYLOAD)
          img.setAttribute('src', src || img.getAttribute(ATTRIBUTE_ORIGINAL))
        }
      }
    }

    $span.slice(0, 3).forEach(span => {
      $thumbSelector.appendChild(span.cloneNode(true))
    })
    $thumbSelector.classList.add(CLASS_SHOW_THUMBS_RIGHT)
    setTimeout(() => {
      $thumbSelector.classList.remove(CLASS_SHOW_THUMBS_RIGHT)
      $span.slice(0, 3).forEach(span => {
        span.parentNode.removeChild(span)
      })
      animate = false
    }, time)
  }

  /**
   * Show previous thumbnails
   *
   * @function showPrev
   * @param {int} param Duration delay
   */
  function showPrev(param) {
    const $li = $sliderThumb.querySelector('span')
    const height = $li.offsetHeight
    const actualMargin =
      parseInt(getComputedStyle($sliderThumb).marginTop, 10)
    const marginTop = -actualMargin > 0 ? actualMargin + height * 4 : 0
    let time = param
    animate = true

    if (time === void 0) {
      time = TIMER
    }

    $sliderThumb.classList.add('animate-thumbs-mt')
    $sliderThumb.style.marginTop = `${marginTop}px`
    setTimeout(() => {
      animate = false
    }, time)
  }

  /**
   * Show next thumbnails
   *
   * @function showNext
   * @param param Duration delay
   */
  function showNext(param) {
    const $li = $sliderThumb.querySelector('span')
    const height = $li.offsetHeight
    const actualMargin = parseInt(getComputedStyle($sliderThumb).marginTop, 10)
    const marginTop = -actualMargin + height * 4 < $sliderThumb.clientHeight
      ? actualMargin - height * 4
      : actualMargin
    let time = param
    animate = true

    if (time === void 0) {
      time = TIMER
    }

    $sliderThumb.classList.add('animate-thumbs-mt')
    $sliderThumb.style.marginTop = `${marginTop}px`
    setTimeout(() => {
      animate = false
    }, time)
  }

  function autoPlay() {
    moveRight($sliderSelector)
  }

  /**
   * Initialisation of slider
   *
   * @function init
   */
  function init() {
    /* Init first image lazyload */
    let picture = $sliderSelector.querySelectorAll('picture')
    let img = $sliderSelector.querySelectorAll('img')
    let thumbPicture = $thumbSelector && $thumbSelector.querySelectorAll('picture') || []
    let thumbImg = $thumbSelector && $thumbSelector.querySelectorAll('img') || []

    for (let i = 0; i < 4; i++) {
      if (picture[i] && picture[i].classList.contains('js-lazyload')) {
        let src = getSrc(picture[i])
        if (src || img[i].getAttribute(ATTRIBUTE_ORIGINAL)) {
          picture[i].classList.remove(CLASS_LAZYLOAD)
          img[i].setAttribute('src', src || img[i].getAttribute(ATTRIBUTE_ORIGINAL))
        }
      }
    }

    for (let i = 0; i < 5; i++) {
      if (thumbPicture[i] && thumbPicture[i].classList.contains('js-lazyload')) {
        let src = getSrc(thumbPicture[i])
        if (src || thumbImg[i].getAttribute(ATTRIBUTE_ORIGINAL)) {
          thumbPicture[i].classList.remove(CLASS_LAZYLOAD)
          thumbImg[i].setAttribute('src', src || thumbImg[i].getAttribute(ATTRIBUTE_ORIGINAL))
        }
      }
    }

    /**
     * On click on slider previous button
     *
     * @listens click
     */
    if (previousSelector) {
      $sliderSelector.querySelector(previousSelector)
      && $sliderSelector.querySelector(previousSelector).bindEvent('click', e => {
        e.stopPropagation()
        if (!animate) {
          let $currentThumbnail = null
          if ($thumbSelector) {
            $currentThumbnail = $thumbSelector.querySelector(`span${SELECTOR_CLASS_ACTIV}`)
          }
          if ($currentThumbnail && $currentThumbnail.index() > limit
              && $currentThumbnail.previousElementSibling) {
            $currentThumbnail.previousElementSibling.click()
          } else if ($currentThumbnail && $currentThumbnail.index() > limit
                     && !$currentThumbnail.previousElementSibling) {
            $thumbSelector.lastElementChild.click()
          } else {
            moveLeft(e)
          }
        }
      })
    }
    /**
     * On click on slider next button
     *
     * @listens click
     */
    if (nextSelector) {
      $sliderSelector.querySelector(nextSelector)
      && $sliderSelector.querySelector(nextSelector).bindEvent('click', e => {
        e.stopPropagation()
        if (!animate) {
          let $currentThumbnail = null
          if ($thumbSelector) {
            $currentThumbnail = $thumbSelector.querySelector(`span${SELECTOR_CLASS_ACTIV}`)
          }
          if ($currentThumbnail && $currentThumbnail.index() > limit
              && $currentThumbnail.nextElementSibling) {
            $currentThumbnail.nextElementSibling.click()
          } else if ($currentThumbnail && $currentThumbnail.index() > limit
                     && !$currentThumbnail.nextElementSibling) {
            $thumbSelector.firstElementChild.click()
          } else {
            moveRight(e)
          }
        }
      })
    }

    /**
     * On click on thumbnails left button, call showLeft
     *
     * @listens click
     */
    if (document.querySelector(thumbPreviousSelector)) {
      if ($thumbSelector.childNodes.length > 4) {
        document.querySelector(thumbPreviousSelector).addEventListener('click', () => {
          if (!animate) {
            showLeft()
          }
        })
      } else {
        document.querySelector(thumbPreviousSelector).style.display = 'none'
      }
    }
    /**
     * On click on thumbnails right button, call showRight
     *
     * @listens click
     */
    if (document.querySelector(thumbNextSelector)) {
      if ($thumbSelector.childNodes.length > 4) {
        document.querySelector(thumbNextSelector).addEventListener('click', () => {
          if (!animate) {
            showRight()
          }
        })
      } else {
        document.querySelector(thumbNextSelector).style.display = 'none'
      }
    }
    /**
     * On click on thumbnails previous button, call showPrev
     *
     * @listens click
     */
    if (sliderThumbPrev) {
      $body.bindEvent('click', sliderThumbPrev, () => {
        if (!animate) {
          showPrev()
        }
      })
    }
    /**
     * On click on thumbnails next button, call showNext
     *
     * @listens click
     */
    if (sliderThumbNext) {
      $body.bindEvent('click', sliderThumbNext, () => {
        if (!animate) {
          showNext()
        }
      })
    }
    /**
     * On resize, reinitializing sliders
     *
     * @method
     * @listens resize
     */
    window.addEventListener('resize', () => {
      if (t) {
        clearTimeout(t)
      }
      t = setTimeout(function () {
        init()
      }, TIMER)
    })
  }

  /**
   * Initialisation et gestion de la galerie de vignettes
   *
   * @function handleThumbnails
   */
  function handleThumbnails() {
    if ($thumbSelector) {
      init()
      $thumbSelector.firstElementChild.classList.add(CLASS_ACTIV)
      thumbItemWidth = $thumbSelector.firstElementChild.offsetWidth
      thumbNbItems = Math.floor($thumbSelector.clientWidth / thumbItemWidth)
      limit = Math.ceil(thumbNbItems / 2)

      if ($thumbSelector.querySelector(SELECTOR_CLASS_ACTIV).index() + 1 >= limit) {
        while ($thumbSelector.querySelector(SELECTOR_CLASS_ACTIV).index() >= limit) {
          $thumbSelector.appendChild($thumbSelector.firstElementChild)
        }
      }

      if ($thumbSelector.childElementCount > thumbNbItems) {
        document.querySelector(thumbPreviousSelector).classList.remove('is-hidden')
        document.querySelector(thumbNextSelector).classList.remove('is-hidden')
      }

      function goTo($source, $target) {
        let index = $target.index()
        const limitRounded = limit % 2 === 0 ? limit : limit - 1
        const rangeToCenter = index - limitRounded
        const rangeToSource = index - $source.index()

        // set activ class
        $source.classList.remove(CLASS_ACTIV)
        $target.classList.add(CLASS_ACTIV)

        const $previousFirstElt = $sliderList.querySelector('li')
        handleCloseVideo($previousFirstElt.firstElementChild)

        // set current image in top gallery
        let $chunk
        if (rangeToSource < 0) {
          $chunk = [...$sliderList.querySelectorAll('li')].slice(rangeToSource)
          $chunk.reverse().forEach(element => {
            $sliderList.insertBefore(element, $sliderList.firstChild)
          })
        } else {
          $chunk = [...$sliderList.querySelectorAll('li')].slice(0, rangeToSource)
          $chunk.forEach(element => {
            $sliderList.appendChild(element)
          })
        }

        const $firstElt = $sliderList.querySelector('li')
        const picture = $firstElt.querySelector('picture')
        const img = $firstElt.querySelector('img')
        handleInitVideo($firstElt.firstElementChild)
        if (img && img.getAttribute(ATTRIBUTE_ORIGINAL)) {
          let src = getSrc(picture)
          if (src || img.getAttribute(ATTRIBUTE_ORIGINAL)) {
            picture.classList.remove(CLASS_LAZYLOAD)
            img.setAttribute('src', src || img.getAttribute(ATTRIBUTE_ORIGINAL))
          }
        }
        $sliderList.querySelector(`li${SELECTOR_CLASS_ACTIV}${SELECTOR_CLASS_CURRENT}`)
                   .classList.remove(CLASS_ACTIV, CLASS_CURRENT)
        $firstElt.classList.add(CLASS_ACTIV, CLASS_CURRENT)
      }

      $thumbSelector.bindEvent('click', 'span, li', function (e) {
        e.stopImmediatePropagation()
        if (document.querySelector(SELECTOR_ZOOM_GAL)
            && !document.querySelector(SELECTOR_ZOOM_GAL).classList.contains(CLASS_SMALL_MOSAIC)) {
          document.querySelector(SELECTOR_ZOOM_GAL)
                  .classList.add(CLASS_SMALL_MOSAIC).classList.remove(CLASS_BIG_MOSAIC)
        }
        /* if (window.sas) {
          sas.refresh(25994, { forceMasterFlag: true })
        }
        ga('send', 'pageview') */
        goTo($thumbSelector.querySelector(SELECTOR_CLASS_ACTIV), e.customCurrentTarget)
      })
    }

    // Zomm thumbnails
    if ($sliderThumb) {
      /**
       * Go to an thumbnail
       *
       * @function goTo
       * @param {jquery} $source
       * @param {jquery} $target
       */
      function goTo($source, $target) {
        if (autoplay) {
          clearInterval(autoInterval)
          autoInterval = setInterval(autoPlay, AUTOPLAY_TIMER)
        }
        let index = $target.index()
        let thumbIndex
        if ($thumbSelector) {
          thumbIndex = $thumbSelector.querySelector(SELECTOR_CLASS_ACTIV).index()
        }
        const rangeToSource = index - $source.index()
        const $zoomGalTop = typeof zoomGalTop === 'string'
          ? $sliderSelector.querySelector(zoomGalTop) : zoomGalTop

        // set activ class
        $source.classList.remove(CLASS_ACTIV)
        $target.classList.add(CLASS_ACTIV)

        // set current image in top gallery
        let $chunk
        if (rangeToSource < 0) {
          $chunk = [...$zoomGalTop.querySelectorAll('li')].slice(rangeToSource)
          $chunk.reverse().forEach(element => {
            $zoomGalTop.querySelector('ul').insertBefore(element, $zoomGalTop.querySelector('ul').firstChild)
          })
        } else {
          $chunk = [...$zoomGalTop.querySelectorAll('li')].slice(0, rangeToSource)
          $chunk.forEach(element => {
            $zoomGalTop.querySelector('ul').appendChild(element)
          })
        }
        const list = $zoomGalTop.querySelector('li')
        const picture = list.querySelector('picture')
        const img = list.querySelector('img')
        if (img && img.getAttribute(ATTRIBUTE_ORIGINAL)) {
          let src = getSrc(picture)
          if (src || img.getAttribute(ATTRIBUTE_ORIGINAL)) {
            picture.classList.remove(CLASS_LAZYLOAD)
            img.setAttribute('src', src || img.getAttribute(ATTRIBUTE_ORIGINAL))
          }
        }

        if ($thumbSelector) {
          $thumbSelector.querySelectorAll('span')[thumbIndex + rangeToSource].click()
        }

        $zoomGalTop.querySelector(`li${SELECTOR_CLASS_ACTIV}${SELECTOR_CLASS_CURRENT}`)
                   .classList.remove(CLASS_ACTIV, CLASS_CURRENT)
        $zoomGalTop.querySelector('li').classList.add(CLASS_ACTIV, CLASS_CURRENT)

        /* if (window.sas) {
          sas.refresh(45733, { forceMasterFlag: true })
        }
        ga('send', 'pageview') */
      }

      /**
       * Handler click on slider thumbnails and goTo this thumbnail
       *
       * @listens click
       */
      $sliderThumb.bindEvent('click', sliderThumbEltClickable, e => {
        e.preventDefault()
        e.stopImmediatePropagation()
        if (document.querySelector(SELECTOR_ZOOM_GAL)
            && !document.querySelector(SELECTOR_ZOOM_GAL).classList.contains(CLASS_SMALL_MOSAIC)) {
          document.querySelector(SELECTOR_ZOOM_GAL).classList.add(CLASS_SMALL_MOSAIC)
          document.querySelector(SELECTOR_ZOOM_GAL).classList.remove(CLASS_BIG_MOSAIC)
        }
        goTo($sliderThumb.querySelector(SELECTOR_CLASS_ACTIV), e.customCurrentTarget)
      })
    }
  }

  // If has thumbnails, init slider and thumbnail
  if ($thumbSelector || $sliderThumb) {
    handleThumbnails()
  } else {
    init()
  }

  if (autoplay) {
    /* Init first image lazyload */
    let picture = $sliderSelector.querySelectorAll('picture')
    let img = $sliderSelector.querySelectorAll('img')

    for (let i = 0; i < 3; i++) {
      if (picture[i].classList.contains('js-lazyload')) {
        let src = getSrc(picture[i])
        if (src || img[i].getAttribute(ATTRIBUTE_ORIGINAL)) {
          picture[i].classList.remove(CLASS_LAZYLOAD)
          img[i].setAttribute('src', src || img[i].getAttribute(ATTRIBUTE_ORIGINAL))
        }
      }
    }
    autoInterval = setInterval(autoPlay, AUTOPLAY_TIMER)
  }

  /**
   * Swipe in slider on mobile
   *
   * @requires jquery
   * @requires jquery/mobile
   * @requires jquery/event/swipe
   * @external jquery
   * @external jquery/mobile
   * @external jquery/event/swipe
   * @listens swiperight
   * @listens swipeleft
   */

  const sliderSelectorHammer = new Hammer($swipeContainer)

  sliderSelectorHammer.on('swiperight', e => {
    if (!animate) {
      const $currentThumbnail = $thumbSelector &&
                                $thumbSelector.querySelector(`span${SELECTOR_CLASS_ACTIV}`)
      if ($currentThumbnail && $currentThumbnail.index() > limit
          && $currentThumbnail.previousElementSibling) {
        $currentThumbnail.previousElementSibling.click()
      } else if ($currentThumbnail && $currentThumbnail.index() > limit
                 && !$currentThumbnail.previousElementSibling) {
        $thumbSelector.lastElementChild.click()
      } else {
        e.currentTarget = $sliderSelector
        moveLeft(e)
      }
    }
  })
  sliderSelectorHammer.on('swipeleft', e => {
    if (!animate) {
      const $currentThumbnail = $thumbSelector &&
                                $thumbSelector.querySelector(`span${SELECTOR_CLASS_ACTIV}`)
      if ($currentThumbnail && $currentThumbnail.index() > limit
          && $currentThumbnail.nextElementSibling) {
        $currentThumbnail.nextElementSibling.click()
      } else if ($currentThumbnail && $currentThumbnail.index() > limit
                 && !$currentThumbnail.nextElementSibling) {
        $thumbSelector.firstElementChild.click()
      } else {
        e.currentTarget = $sliderSelector
        moveRight(e)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/utils/sliderHandler.js